export const studyQuotes = [
  "Coffee: Because sleep is for the weak ☕",
  "Due tomorrow? Do tomorrow! ...Actually, no. Use StudNote instead 📝",
  "I studied for hours! (3 hours = 1 hour TikTok + 2 hours notes)",
  "Procaffeinating: Drinking coffee to delay the inevitable",
  "CTRL+S your life with StudNote 💾",
  "Why sleep when you have StudNote? ...Actually, please sleep 😴",
  "Stressed, blessed, and coffee obsessed ☕",
  "My blood type is espresso ☕",
  "I can and I will. Watch me! (After this nap)",
  "Study mode: Activated. Panic mode: Deactivated... for now 🎯",
  "Finals week: Where dreams go to die, but StudNote saves them! 💪",
  "I don't sweat, I sparkle. Okay, I panic 😅",
  "Brain: Full. Coffee: Empty. Notes: Perfect thanks to StudNote! ✨",
  "The only BS I need is my Bachelor of Science 🎓",
  "Ctrl+Z doesn't work in real life, but StudNote does! 🔄",
  "If you think education is expensive, try ignorance 💡",
  "Study smarter, not harder. That's why you're here! 🧠",
  "Legend says if you say 'due date' three times, an all-nighter appears 🌙",
  "I'm not procrastinating, I'm doing side quests first 🎮",
  "Error 404: Motivation not found. But StudNote is! 🤖",
  "Powered by determination and questionable amounts of caffeine ⚡",
  "You miss 100% of the notes you don't take - Wayne Gretzky - StudNote 📚",
  "Keep calm and let AI take your notes 🤖",
  "I survived another all-nighter thanks to StudNote 🌅",
  "Plot twist: You actually understand the lecture! 🎭"
];

export const getRandomQuote = () => {
  return studyQuotes[Math.floor(Math.random() * studyQuotes.length)];
};
